<template>
  <b-card>
    <b-modal
      id="driver-location-map-modal"
      hide-footer
      @shown="initMap"
    >
      <div
        id="driver-location-map"
      />
    </b-modal>
    <b-card-title class="d-flex justify-content-between align-items-center">
      <h2>Location Details</h2>
      <h4
        v-if="errMessage"
        class="text-danger"
      >
        {{ errMessage }}
      </h4>
    </b-card-title>
    <base-overlay :show="loading">
      <table
        v-if="!loading && data && data.data.data.location"
        class="mt-1"
      >
        <tr v-if="data.data.data.driver.status">
          <th class="pb-50">
            <span class="font-weight-bold">Status:</span>
          </th>
          <td class="pb-50">
            {{ data.data.data.driver.status }}
          </td>
        </tr>
        <tr v-if="data.data.data.score">
          <th class="pb-50">
            <span class="font-weight-bold">Score</span>
          </th>
          <td class="pb-50">
            {{ data.data.data.score }}
          </td>
        </tr>
        <tr v-if="data.data.data.driver.rating">
          <th class="pb-50">
            <span class="font-weight-bold">Rating</span>
          </th>
          <td class="pb-50">
            {{ data.data.data.driver.rating }}
          </td>
        </tr>
        <tr v-if="data.data.data.location">
          <th class="pb-50">
            <span class="font-weight-bold">Location</span>
          </th>
          <td
            class="pb-50 text-primary"
            style="text-decoration: underline;cursor: pointer;"
            @click="$bvModal.show('driver-location-map-modal')"
          >
            {{ data.data.data.location.lat }}, {{ data.data.data.location.lon }}
          </td>
        </tr>
        <tr v-if="data.data.data.zone">
          <th class="pb-50">
            <span class="font-weight-bold">Zone</span>
          </th>
          <td class="pb-50">
            {{ data.data.data.zone }}
          </td>
        </tr>
        <tr v-if="data.data.data.datetime">
          <th class="pb-50">
            <span class="font-weight-bold">Last Datetime</span>
          </th>
          <td class="pb-50">
            {{ new Date(data.data.data.datetime) }}
          </td>
        </tr>
        <tr v-if="data.data.data.connection_id">
          <th class="pb-50">
            <span class="font-weight-bold">Connection ID</span>
          </th>
          <td class="pb-50">
            {{ data.data.data.connection_id }}
          </td>
        </tr>
      </table>

      <h3 class="my-1">
        Driver Services & Zone Capabilities
      </h3>
      <b-table
        v-if="!loading && data && data.data.data.driver.services"
        :items="data.data.data.driver.services"
        :fields="[
          { key: 'name', label: 'Service Name' },
          { key: 'class', label: 'Class' },
          { key: 'metadata.open_for_all_zones', label: 'Open for All Zones', formatter: (value) => value ? 'Yes' : 'No' },
          { key: 'metadata.constrained_zones', label: 'Zone', formatter: (value) => value.length ? value[0] : '-' }
        ]"
        responsive
        striped
        bordered
        small
        class="mt-2"
      />

      <div
        class="d-flex justify-content-center flex-column align-items-center"
      >
        <BButton
          small
          variant="primary"
          @click="fetchDetails"
        >
          Refresh Location
        </BButton>
      </div>
    </base-overlay>
  </b-card>
</template>

<script>
/* eslint-disable no-undef */
import {
  BButton, BCard, BCardTitle, BModal, BTable,
} from 'bootstrap-vue'
import { ref } from '@vue/composition-api'

export default {
  components: {
    BCard, BCardTitle, BButton, BTable, BModal,
  },
  setup(_, ctx) {
    const loading = ref(false)
    const data = ref(null)
    const errMessage = ref(null)
    const fetchDetails = async () => {
      loading.value = true
      errMessage.value = null
      data.value = null
      try {
        if (ctx.root.$route.query.externalId) {
          data.value = await ctx.root.$store.dispatch('drivers/fetchDriverLocation', ctx.root.$route.query.externalId)
        } else {
          errMessage.value = 'External ID of a Driver must be provided'
        }
      } catch (error) {
        errMessage.value = error?.response?.data?.error?.message
      } finally {
        loading.value = false
      }
    }
    fetchDetails()
    const initMap = () => {
      if (!data.value?.data?.data?.location) return
      const { lat, lon } = data.value.data.data.location
      const el = document.getElementById('driver-location-map')
      if (!el) return

      const map = new google.maps.Map(el, {
        zoom: 10,
        center: {
          lat: +lat,
          lng: +lon,
        },
      })

      const marker = new google.maps.Marker({
        position: {
          lat: +lat,
          lng: +lon,
        },
      })
      marker.setMap(map)
    }
    return {
      initMap,
      fetchDetails,
      loading,
      data,
      errMessage,
    }
  },
}
</script>

<style scoped>
#driver-location-map {
  width: 100%;
  height: 300px;
}
</style>
